import {ChangeDetectionStrategy, Component, inject, OnInit} from '@angular/core';
import {AppConfigService} from '../../services/config.service';
import {CopyTooltipBalloonComponent} from '../copy-tooltip/copy-tooltip-balloon.component';

@Component({
    selector:        'copy-tx-explore-tooltip-balloon',
    templateUrl:     './copy-tx-explore-tooltip-balloon.component.html',
    styleUrls:       [
        '../copy-tooltip/copy-tooltip-balloon.component.scss',
        './copy-tx-explore-tooltip-balloon.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host:            {
        '[class.-success]': 'isCopySuccess()'
    },
    standalone:      false
})
export class CopyTxExploreTooltipBalloonComponent extends CopyTooltipBalloonComponent implements OnInit {

    public link: string;

    private readonly appConfigService = inject(AppConfigService);

    public override ngOnInit() {
        this.link = this.createLink(this.content);

        super.ngOnInit();
    }

    private createLink(txHash: string): string {
        let link: string = '';
        const chain = this.appConfigService.appConfig.dex.chain;
        const explorerUrl = chain.blockExplorers?.default?.url;

        if (explorerUrl) {
            link = `${explorerUrl}/tx/${txHash}`;
        }

        return link;
    }

}
